export function buildStatusFilter(options) {
    const { key, status } = options;
    if (!status || !status.length) {
        return undefined;
    }
    return { [key]: { _in: status } };
}
